import {
  createStore,
  applyMiddleware,
  compose,
} from 'redux';
import thunk from 'redux-thunk';
import { apiMiddleware } from 'redux-api-middleware';
import rootReducer from '../reducers';

const middlewares = [apiMiddleware, thunk];
let composedReduxDevTool;
let composeEnhancers;
let enhancer;

switch (process.env.REACT_APP_CONFIG_ENV) {
  case 'prod':
  case 'production':
    enhancer = applyMiddleware(...middlewares);
    break;
  case 'dev':
  case 'development':
  case 'local':
  default:
    /* eslint-disable no-underscore-dangle */
    composedReduxDevTool = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
      ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({ serialize: true })
      : null;
    /* eslint-enable no-underscore-dangle */

    composeEnhancers = composedReduxDevTool || compose;
    enhancer = composeEnhancers(
      applyMiddleware(...middlewares),
    );
    break;
}

const configureStore = preloadedState => createStore(
  rootReducer,
  enhancer,
  preloadedState,
);

export default configureStore;



// WEBPACK FOOTER //
// ./src/config/configureStore.js